import { render, staticRenderFns } from "./LandingCard.vue?vue&type=template&id=4e96ae81&scoped=true&"
import script from "./LandingCard.ts?vue&type=script&lang=ts&"
export * from "./LandingCard.ts?vue&type=script&lang=ts&"
import style0 from "./LandingCard.scss?vue&type=style&index=0&id=4e96ae81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96ae81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
